<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <!--组件在设计器中的样子-->
      <el-form label-position="top">
        <el-form-item label="分类">
          <el-select size="medium" v-model="value.category" disabled placeholder="请选择分类" />
        </el-form-item>
        <el-form-item label="品名">
          <el-select size="medium" v-model="value.name" disabled placeholder="请选择品名" />
        </el-form-item>
        <el-form-item label="库存单位">
          <el-input size="medium" v-model="value.stockUnit" disabled />
        </el-form-item>
      </el-form>
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <!--组件在PC端预览及真实显示的样子-->
      <el-form :inline="true" class="inline-form">
        <el-form-item label="分类">
          <el-select v-model="value.category" placeholder="请选择分类" size="small" clearable filterable
            @change="handleCategoryChange">
            <el-option v-for="category in categories" :key="category" :label="category" :value="category">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品名">
          <el-select class="max-fill" size="medium" v-model="value.name" placeholder="请选择品名" filterable>
            <el-option v-for="item in filteredItems" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库存单位">
          <el-input size="small" v-model="value.stockUnit" disabled />
        </el-form-item>
      </el-form>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <!--组件在移动端预览及真实显示的样子-->
      <el-form label-position="top">
        <el-form-item label="分类">
          <el-select v-model="value.category" placeholder="请选择分类" size="medium" clearable filterable
            @change="handleCategoryChange" style="display: block;">
            <el-option v-for="category in categories" :key="category" :label="category" :value="category">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="品名">
          <el-select class="max-fill" size="medium" v-model="value.name" placeholder="请选择品名" filterable>
            <el-option v-for="item in filteredItems" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库存单位">
          <el-input size="medium" v-model="value.stockUnit" disabled />
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <!--组件在流程实例预览中，只读状态下样子-->
      <el-form label-position="top">
        <el-form-item label="分类">
          <div class="text-ellipsis">
            {{ _value.category }}
          </div>
        </el-form-item>
        <el-form-item label="品名">
          <div class="text-ellipsis">
            {{ _value.name }}
          </div>
        </el-form-item>
        <el-form-item label="库存单位">
          <div class="text-ellipsis">
            {{ _value.stockUnit }}
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
//混入配置
import componentMinxins from '../ComponentMinxins'
import { getEngConsumablesItems } from '@/api/ops/consumables'
import cacheService from '@/utils/cacheService'

export default {
  mixins: [componentMinxins],
  name: "ConServiceItemInput",
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      placeholder: '',
      formItems: [],       // 所有原始数据
      categories: [],      // 去重后的分类列表
      selectedCategory: '', // 选中的分类
      filteredItems: []    // 根据分类筛选后的项目，确保是数组
    }
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }

  },
  watch: {
    'value.category'(newVal) {
      this.updateFilteredItems(newVal);
    },
    // 改进value监听逻辑
    value: {
      handler(newVal, oldVal) {
        // 当分类存在但filteredItems为空时，或者分类发生变化时更新
        if (newVal.category &&
          (this.filteredItems.length === 0 ||
            (oldVal && oldVal.category !== newVal.category))) {
          this.$nextTick(() => {
            this.updateFilteredItems(newVal.category);
          });
        }
        // 处理复制场景：当分类已存在且filteredItems应该有数据但为空时
        else if (newVal.category && this.formItems.length > 0 && this.filteredItems.length === 0) {
          this.updateFilteredItems(newVal.category);
        }
      },
      deep: true,
      immediate: true
    },
    // 添加对品名变化的监听，用于更新库存单位
    'value.name'(newVal) {
      if (newVal && this.filteredItems.length > 0) {
        const selectedItem = this.filteredItems.find(item => item.name === newVal);
        if (selectedItem && this.value.stockUnit !== selectedItem.units) {
          const newValue = {
            ...this.value,
            stockUnit: selectedItem.units
          }
          this.$emit('input', newValue)
        }
      }
    }
  },
  // 在 mounted 钩子中添加判断
mounted() {
  // 判断是否为新添加的空白行（category存在但其他字段应该为空）
  if (this.value.category && !this.value.name && !this.value.stockUnit) {
    // 如果是新添加的行，清空category避免带出上一行的数据
    const newValue = {
      ...this.value,
      category: ''
    }
    this.$emit('input', newValue)
  } else if (this.value.category && this.formItems.length > 0) {
    // 直接执行过滤，不需要等待nextTick
    this.updateFilteredItems(this.value.category);
  }
},
  async created() {
    // 检查缓存中是否有数据
    if (cacheService.has('engConsumablesItems')) {
      const cachedData = cacheService.get('engConsumablesItems');
      this.formItems = cachedData;
      this.categories = [...new Set(cachedData.map(item => item.category))];
    } else {
      // 如果没有缓存，则请求数据
      await this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      try {
        const res = await getEngConsumablesItems();
        this.formItems = res.data.data;
        this.categories = [...new Set(res.data.data.map(item => item.category))];
        
        // 将数据存入缓存
        cacheService.set('engConsumablesItems', res.data.data);
      } catch (error) {
        console.error('获取消耗品数据失败:', error);
      }
    },
    
    // 刷新数据方法
    refreshData() {
      // 清除缓存
      cacheService.clear('engConsumablesItems');
      // 重新获取数据
      this.fetchData();
    },
    updateFilteredItems(categoryVal) {
      if (categoryVal) {
        this.filteredItems = this.formItems.filter(item => item.category === categoryVal);
      } else {
        this.filteredItems = [];
      }
    },

    handleCategoryChange(val) {
      // 当分类改变时，筛选对应的项目
      this.updateFilteredItems(val);

      // 更新value并触发input事件
      const newValue = {
        ...this.value,
        category: val,
        name: '',
        stockUnit: ''
      }
      this.$emit('input', newValue)
    },
    // 添加品名变更处理方法
    handleNameChange(selectedName) {
      if (selectedName) {
        // 根据选中的品名查找对应的项来获取单位
        const selectedItem = this.filteredItems.find(item => item.name === selectedName);
        if (selectedItem) {
          const newValue = {
            ...this.value,
            name: selectedName,
            stockUnit: selectedItem.units
          }
          this.$emit('input', newValue)
        }
      } else {
        // 清空品名时也清空库存单位
        const newValue = {
          ...this.value,
          name: '',
          stockUnit: ''
        }
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped>
.inline-form {
  display: flex;
  align-items: flex-end;
  gap: 15px;
}

.inline-form /deep/ .el-form-item {
  margin-bottom: 0;
}

.inline-form /deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}

.inline-form /deep/ .el-form-item__label {
  font-size: 12px;
  /* 或者你想要的大小 */
}

.readonly .inline-form /deep/ .el-form-item__label {
  font-size: 12px;
  /* 或者你想要的大小 */
}

.text-ellipsis {
  white-space: normal;
  word-wrap: break-word;
  max-width: 100%;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  display: inline-block;
  vertical-align: middle;
}
</style>
